import { fetchProfileForRouteGuard } from '~~/layers/base/composables/fetchProfileForRouteGuard'
import { denyStaffAdminRoute } from '~~/layers/crane-manager/utils/denyStaffAdminRoute'

/**
 * Named route middleware: the Crane panel staff **or** admin tier may enter (`isStaff` / `isAdmin`
 * from `GET /api/profile`: any Crane role, or legacy `is_staff` / `is_admin` without a role).
 * Admins are treated as staff for route access.
 *
 * Anonymous sessions and accounts without either flag are redirected to `/crane-manager/login`.
 *
 * Usage on a page:
 * `definePageMeta({ middleware: 'is-staff' })`
 */
export default defineNuxtRouteMiddleware(async (to) => {
    const profile = await fetchProfileForRouteGuard()
    if (!profile) {
        return denyStaffAdminRoute(to, 'unauthenticated')
    }
    if (!profile.isStaff && !profile.isAdmin) {
        return denyStaffAdminRoute(to, 'forbidden')
    }
})
